// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import DOMPurify from "dompurify";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

interface MarkdownLegalDocumentProps {
  markdown: string;
  className?: string;
}

export function MarkdownLegalDocument({
  markdown,
  className,
}: MarkdownLegalDocumentProps) {
  const sanitizedMarkdown = DOMPurify.sanitize(markdown, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });

  return (
    <div
      className={cn(
        "prose prose-sm sm:prose-base dark:prose-invert max-w-none",
        "prose-headings:text-foreground prose-p:text-muted-foreground",
        "prose-li:text-muted-foreground prose-strong:text-foreground",
        "prose-ul:ps-6 prose-ol:ps-6 prose-li:ps-1",
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml>
        {sanitizedMarkdown}
      </ReactMarkdown>
    </div>
  );
}
